<template>
  <component
    :is="element"
    :class="[$style.sbEllipsisNext, { [$style.sbEllipsisMultilineNext]: lines > 1 }]"
    :style="lines > 1 ? multilineStyle : undefined"
    data-sb-ellipsis-next
    data-sb-regression="sb-ellipsis"
  >
    <slot />
  </component>
</template>

<script setup>
import { computed, toRef, useCssModule, defineOptions, defineProps, watch } from 'vue';

defineOptions({
  name: 'SbEllipsis',
});

const props = defineProps({
  /**
    * Which element to use to create the ellipsis
    */
  element: {
    type: String,
    default: 'span',
  },
  /**
    * Number of lines to be displayed post truncation, only 1 is supported at this time
    */
  lines: {
    type: Number,
    default: 1,
    validator: (val) => val >= 1,
  },
  /**
    * Set of characters to be applied as a suffix post truncation
    * @deprecated This prop is no longer supported and will be removed in a future version
    */
  truncateCharacter: {
    type: String,
    default: '…',
  },
});

const $style = useCssModule();

const lines = toRef(props, 'lines');
const element = toRef(props, 'element');

// Show deprecation warning for truncateCharacter prop
watch(() => props.truncateCharacter, (newValue) => {
  if (newValue !== '…') {
    console.warn('[SbEllipsis] The "truncateCharacter" prop is deprecated and no longer supported. It will be removed in a future version.');
  }
}, { immediate: true });

const multilineStyle = computed(() => ({
  WebkitLineClamp: lines.value,
  lineClamp: lines.value,
}));
</script>

<style lang="scss" module>
@use '@src/components/Ellipsis/style/sb-ellipsis.module.scss';
</style>
